import script from "./EventSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./EventSlider.vue?vue&type=script&setup=true&lang=js"

import "./EventSlider.vue?vue&type=style&index=0&id=724967de&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-724967de"]])

export default __exports__